import React from 'react'
import { connect } from 'react-redux'
import { string, bool } from 'prop-types'
import MdChevronLeft from 'react-icons/lib/md/chevron-left'
import MdChevronRight from 'react-icons/lib/md/chevron-right'

const CloseButton = ({ searchContent, theme }) =>
  searchContent ? (
    <MdChevronLeft color={theme} />
  ) : (
    <MdChevronRight color="white" />
  )

const CLoseButtonContainer = ({ searchContent, theme }) => (
  <span id="close-icons">
    <CloseButton searchContent={searchContent} theme={theme} />
  </span>
)

CloseButton.propTypes = {
  theme: string.isRequired,
  searchContent: bool.isRequired,
}

CLoseButtonContainer.propTypes = {
  theme: string.isRequired,
  searchContent: bool.isRequired,
}

const mapStateToProps = ({ spi }) => ({
  theme: spi.theme,
})

export default connect(mapStateToProps)(CLoseButtonContainer)



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/CloseSearchContent/Buttons.jsx